import * as React from 'react'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import ActionsButtons from 'modules/bookkeepers/components/IncidenceInformation/ActionsButtons'
import useFetchIncidenceDetails from 'modules/bookkeepers/hooks/useFetchIncidenceDetails'
import useGetCurrentIncidence from 'modules/bookkeepers/hooks/useGetCurrentIncidence'
import { CurrentIncidenceProvider } from 'modules/bookkeepers/lib/CurrentIncidenceContext'
import { IncidenceDetailProvider } from 'modules/bookkeepers/lib/IncidenceDetailContext'
import { translatedIncidenceName } from 'modules/bookkeepers/lib/dynamicTranslations'
import { INCIDENCE_STATUSES } from 'modules/payroll_bundle/lib/Incidences/Status'

interface Props {
  children: React.ReactNode
  open: boolean
  closeSidePanel: () => void
}

const DetailSidepanel = ({ children, open, closeSidePanel }: Props) => {
  const { incidence } = useGetCurrentIncidence()
  const employeeName = incidence?.employee?.fullName

  const incidenceDetails = useFetchIncidenceDetails(incidence?.id)

  const bookkeepersStatuses =
    incidence?.status === INCIDENCE_STATUSES.to_do ||
    incidence?.status === INCIDENCE_STATUSES.doing ||
    incidence?.status === INCIDENCE_STATUSES.done ||
    incidence?.status === INCIDENCE_STATUSES.discarded

  return (
    <>
      {incidence && (
        <CurrentIncidenceProvider incidence={incidence}>
          <IncidenceDetailProvider incidenceDetails={incidenceDetails}>
            <Sidepanel
              overlay={false}
              boxPadding={false}
              width="wide"
              title={
                employeeName
                  ? i18n.t('bookkeepers.incidence.details.header', {
                      incidence_name: translatedIncidenceName(incidence.name, incidence.customName),
                      employee_name: employeeName,
                    })
                  : translatedIncidenceName(incidence.name, incidence.customName) || ''
              }
              onClose={closeSidePanel}
              open={open}
              headerBorder={false}
              closeLabel={i18n.t('common.close')}
              footer={bookkeepersStatuses && <ActionsButtons />}
            >
              {children}
            </Sidepanel>
          </IncidenceDetailProvider>
        </CurrentIncidenceProvider>
      )}
    </>
  )
}

export default DetailSidepanel
